(() => {
  const experimentId = 'd4558cde-5fbd-4203-97a3-847df94e0e39';
  const variantGroupId = '432019e7-b0f4-41f1-9180-554ab74a69fc';
  const variantClass = 'ig-cart-accessory-gift-prompt-variant';
  const hostSelector = '[data-rebuy-id="249459"][data-accessory-gift-prompt]';
  let initialized = false;

  const applyPrompt = () => {
    document.querySelectorAll(hostSelector).forEach((host) => {
      const title = host.querySelector('.primary-title');
      const promptLineOne = host.dataset.accessoryGiftPromptLineOne?.trim();
      const promptLineTwoPrefix = host.dataset.accessoryGiftPromptLineTwoPrefix?.trim();
      const promptEmphasis = host.dataset.accessoryGiftPromptEmphasis?.trim();

      if (!title || !promptLineOne || !promptLineTwoPrefix || !promptEmphasis) return;

      const currentLines = title.querySelectorAll('.cart-accessory-gift-prompt__line');
      const currentEmphasis = currentLines[1]?.querySelector('.cart-accessory-gift-prompt__emphasis');
      const promptIsCurrent =
        currentLines.length === 2 &&
        currentLines[0].textContent.trim() === promptLineOne &&
        currentLines[1].textContent.trim() === `${promptLineTwoPrefix} ${promptEmphasis}` &&
        currentEmphasis?.textContent.trim() === promptEmphasis;

      if (!promptIsCurrent) {
        const lineOne = document.createElement('span');
        const lineTwo = document.createElement('span');
        const emphasis = document.createElement('strong');

        lineOne.className = 'cart-accessory-gift-prompt__line';
        lineTwo.className = 'cart-accessory-gift-prompt__line';
        emphasis.className = 'cart-accessory-gift-prompt__emphasis';
        lineOne.textContent = promptLineOne;
        lineTwo.append(document.createTextNode(`${promptLineTwoPrefix} `), emphasis);
        emphasis.textContent = promptEmphasis;
        title.replaceChildren(lineOne, lineTwo);
      }

      host.classList.add('cart-accessory-gift-prompt');
    });
  };

  const observeCart = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    new MutationObserver((mutations) => {
      const widgetChanged = mutations.some((mutation) => {
        if (mutation.target.closest?.(hostSelector)) return true;

        return Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches?.(hostSelector) || node.querySelector?.(hostSelector);
        });
      });

      if (widgetChanged) applyPrompt();
    }).observe(cartDrawer, { childList: true, subtree: true });
  };

  const initializeVariant = () => {
    if (initialized) return;
    initialized = true;
    document.documentElement.classList.add(variantClass);

    const initializeCart = () => {
      applyPrompt();
      observeCart();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCart, { once: true });
    } else {
      initializeCart();
    }

    document.addEventListener('rebuy.ready', applyPrompt);
    document.addEventListener('rebuy:cart.change', () => {
      queueMicrotask(() => {
        document.querySelectorAll('cart-progress-bar').forEach((progressBar) => {
          if (progressBar.isConnected && typeof progressBar.render === 'function') {
            progressBar.render();
          }
        });
      });
    });
  };

  const applyGate = () => {
    const testGroup = window.igData?.user?.getTestGroup(experimentId);
    if (testGroup?.id === variantGroupId) initializeVariant();
  };

  const previewParameters = new URLSearchParams(window.location.search);
  const previewExperimentId = previewParameters.get('ig-preview');
  const previewGroupId = previewParameters.get('igTg');
  if (previewExperimentId === experimentId && previewGroupId === variantGroupId) {
    initializeVariant();
  }

  if (window.igData?.user) {
    applyGate();
  } else {
    window.addEventListener('ig:ready', applyGate, { once: true });
  }
})();
